/**
 * The Blocked band's look and labels, shared by the Day grid (DNKADM-0373 U2) and the
 * Week grid (HOTFIX: the Week view draws blocks the same way). A plain module so neither
 * grid has to export non-components.
 */
import type { CalendarMaps } from '@/theme/maps/calendar';

/** The hatched, non-interactive treatment of a blocked span — clearly not a booking. */
export function blockedBandSx(cm: CalendarMaps): object {
  return {
    position: 'absolute',
    zIndex: 2,
    borderRadius: '6px',
    border: `1px dashed ${cm.textMuted}`,
    backgroundImage: `repeating-linear-gradient(135deg, ${cm.neutralStatusBg} 0 6px, transparent 6px 12px)`,
    bgcolor: cm.cancelledFill,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    p: '4px 6px',
    overflow: 'hidden',
    pointerEvents: 'none',
  };
}

/** `9 AM` / `9:30 AM` for a fractional hour (blocked-band labels). */
export function formatAxisTime(hour: number): string {
  const whole = Math.floor(hour);
  const minutes = Math.round((hour - whole) * 60);
  const period = whole >= 12 && whole < 24 ? 'PM' : 'AM';
  const hour12 = whole % 12 || 12;
  return minutes === 0 ? `${hour12} ${period}` : `${hour12}:${String(minutes).padStart(2, '0')} ${period}`;
}

/** `${lane} blocked 9 AM–12 PM` — the band's accessible name on both grids. */
export function blockedAriaLabel(laneLabel: string, startHour: number, endHour: number): string {
  return `${laneLabel} blocked ${formatAxisTime(startHour)}–${formatAxisTime(endHour)}`;
}
